/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_History_Note_Edited_MarkerInputs */

const en_case_history_note_edited_marker = /** @type {(inputs: Case_History_Note_Edited_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(edited)`)
};

const pt_br2_case_history_note_edited_marker = /** @type {(inputs: Case_History_Note_Edited_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(editada)`)
};

/**
* | output |
* | --- |
* | "(edited)" |
*
* @param {Case_History_Note_Edited_MarkerInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_history_note_edited_marker = /** @type {((inputs?: Case_History_Note_Edited_MarkerInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_History_Note_Edited_MarkerInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_history_note_edited_marker(inputs)
	return pt_br2_case_history_note_edited_marker(inputs)
});